import { styled } from "@mui/material/styles";

type ColumnDividerProps = { timestamp: number; startDate: Date; endDate: Date };

const Divider = styled("div")(({ theme }) => ({
  "&.ScheduleRow-divider": {
    position: "absolute",
    top: 0,
    height: "100%",
    borderLeft: "1px solid",
    borderColor: theme.palette.divider,
  },
}));

const ColumnDivider: React.FC<ColumnDividerProps> = (props) => {
  const { timestamp, startDate, endDate } = props;

  return (
    <Divider
      className="ScheduleRow-divider"
      style={{
        left: `${((timestamp - startDate.getTime()) / (endDate.getTime() - startDate.getTime())) * 100}%`,
      }}
    />
  );
};

export default ColumnDivider;
